import React from 'react';
import Icon from '../Icon';

export default function CircleExclamationIcon({ color, className, size }) {
  return (
    <Icon icon="circle-exclamation" color={color} className={className} size={size} />
  );
}
